// @flow
import React from 'react'
import renderHTML from 'react-render-html'
import './styles.scss'

export default class Tipp extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
      isMobile: window.innerWidth < 650,
      isTablet: window.innerWidth < 800
    }
  }

  render() {
    return (
      <div className='tipp'>
        <p><span style={{ left: '-10px', position: 'relative', fontSize: '1.05em' }}><strong>{this.props.title}{' '}{this.props.impact}</strong></span>{this.props.children}</p>
      </div>
    )
  }
}
